import React, {useEffect, useState} from 'react'
import {ChevronDownIcon, ChevronRightIcon, TrashIcon} from "@heroicons/react/24/solid";
import _ from 'lodash'
import ShowDesignVariantStatus from "../common/show-design-variant-status";
import ShowParentProductColorList from "../common/show-parent-product-color-list";
import ShowProductColorTags from "../common/show-product-color-tags";

const PublisherDesignVariantList = ({designDetail, selectedVariant, setSelectedVariant, setSelectedProductColor}) => {

    return (
        <>

            <div
                className="overflow-y-scroll form-container design-variant-list-container">
                <div className="px-2">
                    {designDetail?.variants?.map((variant, index) => (
                        <React.Fragment key={index}>
                            <div onClick={() => {
                                setSelectedVariant(variant);

                                if (setSelectedProductColor && variant?.colors) {
                                    setSelectedProductColor(variant?.colors[0]);
                                }
                            }}
                                 className={`flex justify-between my-2 cursor-pointer rounded border ${selectedVariant?.id === variant?.id ? 'bg-purple-100 text-purple-700 shadow-xl border-4 border-purple-600' : 'border-gray-400 bg-white'}`}>

                                <div className="p-4 align-middle flex justify-between w-full">
                                    <div className="flex justify-start w-full">
                                        <div
                                            className="font-semibold mr-2">#{index + 1}</div>
                                        <div className="w-full">
                                            <div
                                                className="align-middle">{variant?.name}</div>

                                            <div className="flex justify-between w-full">
                                                <div className="mt-2">
                                                    {variant?.colors?.length > 0 &&
                                                        <ShowProductColorTags parent={variant}/>
                                                    }

                                                    {!variant?.colors &&
                                                        <div className="text-red-400 font-semibold ml-1">No Product
                                                            Colors</div>
                                                    }
                                                </div>

                                                <div className="align-middle">
                                                    <ShowDesignVariantStatus
                                                        designVariantDetail={variant}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </React.Fragment>
                    ))}
                </div>
            </div>

        </>
    )
}

export default PublisherDesignVariantList
